import { ActionReducerMap, ActionReducer, Action } from '@ngrx/store';
import { RootState } from '../../models/rootState.model';

import { HeaderReducer } from './header.reducer';
import { AuthReducer } from './authentication.reducers';
import { ApiReducer } from './api.reducers';
import { InternetReducer } from './internet.reducers';
import { routerReducer } from '@ngrx/router-store';
import { MainContextReducer } from './context.reducers';
import { SportsReducer } from './sports.reducers';
import { SportActiveReducer } from './sport-active.reducers';
import { SessionReducer } from './session.reducers';
import { JobsReducer } from './contributor-jobs.reducers';


export const rootReducers: ActionReducerMap<RootState> = {
    auth: AuthReducer,
    api: ApiReducer,
    internet: InternetReducer,
    header: HeaderReducer,
    router: (routerReducer as ActionReducer<any, Action>),
    context: MainContextReducer,
    sports: SportsReducer,
    sport_active: SportActiveReducer,
    session: SessionReducer,
    jobs: JobsReducer
}